import React, { PropsWithChildren } from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Trash from 'components/shared/Icon/icons/Trash';
import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';

type Props = PropsWithChildren<{
  onClickDelete: () => void;
  onClickEdit: () => void;
  isHasName: boolean;
}>;

function GuestCard({ children, isHasName, onClickDelete, onClickEdit }: Props) {
  return (
    <div className={styles.guestsItemWrapper}>
      <div className={styles.guestsItemContainer}>
        <div className={styles.guestsItemContent}>
          <Text accent className={cx(styles.guestName, !isHasName && styles.guestNameUntitled)}>
            {children}
          </Text>

          <div className={styles.guestActions}>
            <Text accent className={styles.guestActionsEdit} onClick={onClickEdit}>
              Edit
            </Text>

            <Icon component={Trash} className={styles.icon} onClick={onClickDelete} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuestCard;
